import {
    ng
} from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import {
    NotificationService
} from '../../../../../../app.common/modules/common/services/notification.service';
import { IPasswordCheck } from '../../../../model/IActiveStaffsFilter';
import { DiscountForStaffService } from '../../../discount-for-staff.service';

class DiscountForStaffConfirmPassword implements ng.IController {
    public static $inject = ['$scope', '$translate', '$timeout', 'notificationService', 'discountForStaffService'];
    public modalInstance: ng.ui.bootstrap.IModalServiceInstance = this as any;
    public waiting: boolean;
    public confirmPassword: string = '';
    public hasError: boolean = false;

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $timeout: ng.ITimeoutService,
        public notificationService: NotificationService,
        public discountForStaffService: DiscountForStaffService
    ) {}

    public ok = () => {
        const passwordCheck: IPasswordCheck = {
            Password: this.confirmPassword
        };
        this.notificationService.showWaitingMessage();
        this.discountForStaffService.checkPassword(passwordCheck)
            .then((result) => {
                if (result) {
                    this.modalInstance.close({
                        $value: 'ok'
                    });
                } else {
                    this.hasError = true;
                }
            })
            .catch((error) => {
                this.notificationService.showErrorMessage(error);
            })
            .then(() => this.notificationService.clearAll());
    }

    public close = () => {
        this.modalInstance.close({
            $value: 'close'
        });
    }

    public showHidePassword = () => {
        return {
            require: 'ngModel',
            restrict: 'A',
            link(scope: ng.IScope, element: JQLite, attr: ng.IAttributes, ctrl: ng.IController) {
                scope.$watch(attr.showPassword, function(newVal: boolean, oldVal: boolean) {
                    if (newVal) {
                        element.attr('type', 'text');
                    } else {
                        element.attr('type', 'password');
                    }
                });
            }
        };
    }

    public clearPassword() {
        this.confirmPassword = '';
    }

}

angular.module('naut').component('discountForStaffConfirmPassword', {
    template: require('./discount-for-staff-confirm-password.component.html'),
    controller: DiscountForStaffConfirmPassword,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/special-tab/active-tab/confirm-password/discount-for-staff-confirm-password.component.ts